import apiUrl from '../../../constants'
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading'
import PieChart from "./charts.js";
import {
	Validator
} from 'vee-validate'
import check_unauthorized from '../../../unauthorizedres'
import VOffline from 'v-offline';
import DetectedSpeed from 'vue-identify-network';



export default {
	name: 'dashboard',
	components: {
		VueElementLoading,
		PieChart,
		VOffline,
		DetectedSpeed
	},
	props: [],
	data() {
		return {
			warehouseid: '',
			client: '',
			warehouse:'',
			dockReceiptData: [],
			grcData: [],
			putAwayData: [],
			orderOutboundData: [],
			pickingData: [],
			packingData: [],
			shippingData: [],
			SRData: [],
			RtoData:[],

			chartOptionsDR: {},
			chartOptionsGRC: {},
			show: '1',
			chartSeriesGRC: [],
			chartSeriesDR: [],

			chartSeriesGRCMonth: [],
			chartSeriesDRMonth: [],

			todayHrs: 0,
			monthHrs: 0,

			// DR Box Chart
			drTodaychartData: {
				labels: ['Accepted Boxes', 'Rejected Boxes'],
				datasets: [{
					label: "DR Box Data",
					backgroundColor: ["#41B883", "#00D8FF"]
				}],
				display: 0,
			},
			drMonthchartData: {
				labels: ['Accepted Boxes', 'Rejected Boxes'],
				datasets: [{
					label: "DR Box Data",
					backgroundColor: ["#41B883", "#04385d"]
				}],
				display: 0,
			},
			// GRC Accepted / Rejected

			grcTodaychartData: {
				labels: ['GRC Accepted Items', 'GRC Rejected Items'],
				datasets: [{
					label: "GRC Data",
					backgroundColor: ["#ac87af", "#dc1919"]
				}],
				display: 0,
			},
			grcMonthchartData: {
				labels: ['GRC Accepted Items', 'GRC Rejected Items'],
				datasets: [{
					label: "GRC Data",
					backgroundColor: ["#ac87af", "#dc1919"]
				}],
				display: 0,
			},

			checkAll: 0,
			isLoading: false,
			showButtonRefresh: false,
			onLine: true,
			speed: 0,
			networkType: null
		}
	},
	computed: {

		checkAllLoadded: function() {
			if (this.checkAll == 9) {
				this.isLoading = false;
				return true;
			}
		},
	},
	mounted() {
		if (this.$route.query.check == 1) {
			this.$alertify.error("Unauthorised user, Please contact your system admin");
		}
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		
		switch (this.user_type) {
			case 'system_user':
				break;
			case 'client_user':
				this.client = userdetail.clientid;
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showButtonRefresh = true;
				//	this.isLoading = true;

				// this.getDockReceipt();
				// this.getGrc();
				// this.getPutAway();
				// this.getOrderOutbound();
				// this.getPicking();
				// this.getPacking();
				// this.getShipping();
				break;
			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		if(this.warehouse && Number(this.warehouse)>0)
		{
			this.warehouseid = this.warehouse
		}
		if(this.warehouse && this.client && this.warehouse!='' && this.client>0)
			this.showButtonRefresh = true;
	},
	methods: {
		// handleNetworkIdentified(type) {
		// 	this.networkType = type
		// },
		// handleNetworkSpeed(speed) {
		// 	this.speed = speed
		// },
		// amIOnline(e) {
		// 	this.onLine = e;
		// },
		refreshLog() {
			if(Number(window.localStorage.getItem('selectedClient'))>0)
			{
				this.client  = window.localStorage.getItem('selectedClient')
			}

			if(Number(window.localStorage.getItem('selectedWarehouse'))>0)
			{
				this.warehouse  = window.localStorage.getItem('selectedWarehouse')
				this.warehouseid = this.warehouse;
			}

			if(this.client=='' || this.warehouse=='' || this.warehouse =='undefined' || this.client =='undefined')
			{
				this.$alertify.error("Please select warehouse and client");
				return false;
			}
			
			this.isLoading = true
			this.checkAll = 0
			this.getDockReceipt()
			this.getGrc()
			this.getPutAway()
			this.getOrderOutbound()
			this.getPicking()
			this.getPacking()
			this.getShipping()
			this.getSR()
			this.getRTO()

		},
		calculateTodatMonthHrs(val, todayMonth) {
			let retunVal = 0;
			if (todayMonth == 'today') {
				let hrs = this.todayHrs ? this.todayHrs : this.getHrs(todayMonth);
				retunVal = val / hrs;
			} else {
				let hrs = this.monthHrs ? this.monthHrs : this.getHrs(todayMonth);
				retunVal = val / hrs;
			}
			if (retunVal > 0 && retunVal.toFixed(2) == 0.00)
				return retunVal.toFixed(4);

			return retunVal.toFixed(2);
		},
		getHrs(todayMonth) {
			let hours;
			if (todayMonth == 'today') {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
				let date1 = firstDay.getTime();
				let date2 = new Date().getTime();
				hours = Math.abs(date2 - date1) / 36e5;
				this.todayHrs = hours;
			} else {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				let date1 = firstDay.getTime();
				let date2 = new Date().getTime();
				hours = Math.abs(date2 - date1) / 36e5;
				this.monthHrs = hours;
			}
			return hours;
		},
		getSum(arr) {
			return arr.reduce(function(arr, num) {
				return Number(arr) + Number(num)
			}, 0);
		},
		getDockReceipt() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardDockReceipt',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.dockReceiptData = result.data;
				this.drTodaychartData.datasets[0].data = [this.dockReceiptData.today.accepted, this.dockReceiptData.today.rejected];
				this.drMonthchartData.datasets[0].data = [this.dockReceiptData.month.accepted, this.dockReceiptData.month.rejected];
				if (this.getSum(this.drTodaychartData.datasets[0].data) > 0)
					this.drTodaychartData.display = 1;
				if (this.getSum(this.drMonthchartData.datasets[0].data) > 0)
					this.drMonthchartData.display = 1;
				this.checkAll++;
			}, error => {
				console.log(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},
		getGrc() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardWarehouseGRC',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.grcData = result.data;
				this.grcTodaychartData.datasets[0].data = [this.grcData.today.accepted, this.grcData.today.rejected];
				this.grcMonthchartData.datasets[0].data = [this.grcData.month.accepted, this.grcData.month.rejected];
				if (this.getSum(this.grcTodaychartData.datasets[0].data) > 0)
					this.grcTodaychartData.display = 1;
				if (this.getSum(this.grcMonthchartData.datasets[0].data) > 0)
					this.grcMonthchartData.display = 1;
				this.checkAll++;
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},
		getPutAway() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardWarehousePutAway',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.putAwayData = result.data;
				this.checkAll++;
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},
		getOrderOutbound() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardWarehouseOrderOutbound',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.orderOutboundData = result.data;
				this.checkAll++;
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})

		},
		getPicking() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardWarehousePicking',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.pickingData = result.data;
				this.checkAll++;
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},
		getPacking() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardWarehousePacking',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.packingData = result.data;
				this.checkAll++;
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},
		getShipping() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardWarehouseShipping',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.shippingData = result.data;
				
				this.checkAll++;
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},
		getRTO() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardRTO',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.RtoData = result.data;
				this.checkAll++;
				console.log(this.RtoData.month.rtoputaway ,"-------------------------")
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})

		},

		getSR() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				clientid:this.client,
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'dashboardSR',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(result => {
				this.SRData = result.data;
				this.checkAll++;

				console.log(this.SRData,"sssssssssssssssssssrrrrrrrrrrrrrrrrrrrrrrr")
			}, error => {
				console.error(error);
				check_unauthorized.unauthorized(error.response.status);
			})
		},

		
	}
}


// WEBPACK FOOTER //
// ./src/views/components/dashboard/dashboard.component.js